<div class="benefits-requirements" #benefitsRequirements data-section-id="benefits-requirements-section" data-section-name="Benefits Requirements">
  <app-container>
    <div class="benefits-requirements__header">
      <h2 class="benefits-requirements__title">¿Qué es Unipay?</h2>
      <p class="benefits-requirements__subtitle">Unipay es una <b>Tarjeta de Crédito 100% digital</b> que te permite pagar de forma rápida y segura sólo usando tu huella.</p>
    </div>

    <div class="benefits-requirements__grid">
      <!-- Beneficios principales -->
      <div class="benefits-requirements__card benefits-requirements__card--benefits">
        <h3 class="benefits-requirements__card-title">¿Qué puedes hacer con Unipay?</h3>

        <div class="benefits-requirements__list">
          <div class="benefits-requirements__item">
          </div>
          <div class="benefits-requirements__item">
            <div class="benefits-requirements__icon">
              <img src="https://www.unipay.cl/api/descargaArchivo/web-icono_01.png" alt="Icono 1">
            </div>
            <div>
              <p class="benefits-requirements__text">
                <b>Comprar</b> de forma presencial en <b>Unimarc, Super 10 y Alvi</b>. Y online en <b>Unimarc.cl y App Unimarc</b>
              </p>
            </div>
          </div>

          <div class="benefits-requirements__item">
            <div class="benefits-requirements__icon">
              <img src="https://www.unipay.cl/api/descargaArchivo/web-icono_01.png" alt="Icono 1">
            </div>
            <div>
              <p class="benefits-requirements__text">
               <b>Paga fácil en Unired.cl tus cuentas</b> de luz, agua, gas, autopistas y más
              </p>
            </div>
          </div>

          <div class="benefits-requirements__item">
            <div class="benefits-requirements__icon">
              <img src="https://www.unipay.cl/api/descargaArchivo/web-icono_01.png" alt="Icono 1">
            </div>
            <div>
              <p class="benefits-requirements__text">
                <b>Solicita Avances y Super Avances</b> cuando lo necesites, de forma rápida y simple
              </p>
            </div>
          </div>
          <div class="benefits-requirements__item">
            <div class="benefits-requirements__icon">
              <img src="https://www.unipay.cl/api/descargaArchivo/web-icono_01.png" alt="Icono 1">
            </div>
            <div>
              <p class="benefits-requirements__text">
                <b>Disfruta descuentos y promociones</b> exclusivas pagando con tu tarjeta digital Unipay
              </p>
            </div>
          </div>
          <div class="benefits-requirements__item">

            <div>
            </div>
          </div>
        </div>
      </div>

      <!-- Requisitos para postular -->
      <div class="benefits-requirements__card benefits-requirements__card--requirements">
        <h3 class="benefits-requirements__card-title">Requisitos para postular</h3>

        <div class="benefits-requirements__list">
          <div class="benefits-requirements__item">
          </div>
          <div class="benefits-requirements__item">
            <div class="benefits-requirements__number"><img src="https://www.unipay.cl/api/descargaArchivo/web-icono02.png" alt="Icono 1"></div>
            <div>
              <p class="benefits-requirements__text">
                Tener entre <span class="benefits-requirements__text--bold">30 y 74 años.</span>
              </p>
            </div>
          </div>

          <div class="benefits-requirements__item">
            <div class="benefits-requirements__number"><img src="https://www.unipay.cl/api/descargaArchivo/web-icono03.png" alt="Icono 1"></div>
            <div>
              <p class="benefits-requirements__text">
                Cédula de identidad <span class="benefits-requirements__text--bold">vigente</span> y sin bloqueo.
              </p>
            </div>
          </div>

          <div class="benefits-requirements__item">
            <div class="benefits-requirements__number"><img src="https://www.unipay.cl/api/descargaArchivo/web-icono05.png" alt="Icono 1"></div>
            <div>
              <p class="benefits-requirements__text">
                Ingresos <span class="benefits-requirements__text--bold">acreditables</span>, recurrentes y estables.
              </p>
            </div>
          </div>

          <div class="benefits-requirements__item">
            <div class="benefits-requirements__number"><img src="https://www.unipay.cl/api/descargaArchivo/web-icono04.png" alt="Icono 1"></div>
            <div>
              <p class="benefits-requirements__text">
                Teléfono celular <span class="benefits-requirements__text--bold">activo.</span>
              </p>
            </div>
          </div>

           
        </div>
      </div>
    </div>

    <div class="benefits-requirements__actions">
      <a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Pagina_Unipay&utm_campaign=queesunipay" 
      target="_blank" 
      rel="noopener noreferrer"
      class="benefits-requirements__button" 
      (click)="onCTAClick()">
        <span class="benefits-requirements__button-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="benefits-requirements__button-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
            />
          </svg>
          Solicita tu Unipay aquí
        </span>
      </a>

      <a routerLink="/bases-legales" class="benefits-requirements__link" (click)="onBasesLegalesClick()">
        Revisar bases legales
      </a>
    </div>
  </app-container>
</div>
